import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { getServerErrorRoute } from '../../utils/routes';

const ErrorRedirect = ({ error }) => {
  const { statusCode, key } = error;

  return (
    <Redirect to={{ pathname: getServerErrorRoute(statusCode), state: key }} />
  );
};

ErrorRedirect.propTypes = {
  error: PropTypes.shape({
    statusCode: PropTypes.number,
    key: PropTypes.string,
  }),
};

ErrorRedirect.defaultProps = {
  error: {
    statusCode: 500,
    key: '',
  },
};

export default ErrorRedirect;
